import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-backtop",
  "use": "icon-backtop-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"icon-backtop\"><g><path fill-opacity=\"0\" d=\"M0 0h40v40H0z\" /><path d=\"M19.529 15.194a.654.654 0 01.908 0l6.352 6.187c.502.489.333.885-.377.885h-3.858v6.484c0 .69-.575 1.25-1.285 1.25h-2.572c-.71 0-1.286-.56-1.286-1.25v-6.484h-3.857c-.71 0-.879-.397-.377-.885l6.352-6.187zm8.186-2.694h-15.43c-.709 0-1.285-.56-1.285-1.25S11.576 10 12.285 10h15.43c.709 0 1.285.56 1.285 1.25s-.576 1.25-1.285 1.25z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol